'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _credentialsConfig = require('./credentials-config');

var _credentialsConfig2 = _interopRequireDefault(_credentialsConfig);

var _storage = require('./lib/storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint camelcase: [0] */

exports.default = {
  maxAppLevelRedirects: 10,
  maxLocusRedirects: 5,
  maxAuthenticationReplays: 1,
  maxReconnectAttempts: 1,
  onBeforeLogout: [],
  trackingIdPrefix: 'spark-js-sdk',
  trackingIdSuffix: '',
  AlternateLogger: undefined,
  credentials: new _credentialsConfig2.default(),
  device: {
    preDiscoveryServices: {
      hydraServiceUrl: process.env.HYDRA_SERVICE_URL || 'https://api.ciscospark.com/v1'
    },
    validateDomains: process.env.VALIDATE_DOMAINS === 'true' || false,
    // It is okay to pass the auth token to the following domains:
    whitelistedServiceDomains: ['webexkubed.com', 'wbx3.com', 'wbx2.com', 'ciscospark.com', 'webex.com']
  },
  payloadTransformer: {
    predicates: [],
    transforms: []
  },
  storage: {
    boundedAdapter: _storage.MemoryStoreAdapter,
    unboundedAdapter: _storage.MemoryStoreAdapter
  }
};
//# sourceMappingURL=config.js.map
